module.exports = __webpack_public_path__ + "img/overclock.4dd7a733.png";